<template>
    <div v-if="activeLocation === 'loading'"><i class="fas fa-circle-notch fa-spin"></i> Loading Service Dashboard ...</div>
    <div v-else-if="activeLocation.status !== 'active'">
        <base-alert class="mt-5" type="danger">Dieser Standort ist nicht aktiv und kann daher nicht genutzt werden.</base-alert>
    </div>
    <protocol-create v-else-if="!activeLocation.playerCheckAllowed"></protocol-create>
    <Spielercheck v-else-if="activeLocation.oasisid === null || activeLocation.oasisid === '' || typeof activeLocation.oasisid === 'undefined'"/>
    <OasisSpielercheck v-else />
</template>

<script>
    import Spielercheck from "@/views/ServiceDashboard/Spielercheck/Spielercheck";
    import OasisSpielercheck from "@/views/ServiceDashboard/Spielercheck/OasisSpielercheck";
    import ProtocolCreate from "@/views/Protocols/create";
    export default {
        name: "SpielerCheckController",
        components: {ProtocolCreate, OasisSpielercheck, Spielercheck},
        created() {
            if (!this.$store.getters['location/isReady']) {
                this.$store.dispatch('location/getLocationCollection') }
        },
        computed: {
            activeProfile() {
                return this.$store.getters['profiles/showActiveProfile'];
            },
            activeLocation() {
                return (this.$store.getters['location/isReady']) ? this.$store.getters['location/showLocationByIRI']('/api/locations/'+this.$store.getters['authentication/location']) : 'loading';
            }
        }
    }
</script>

<style scoped>



</style>